import React from "react";
import { useTranslation } from "react-i18next";
import MnLink from "./atoms/MnLink";
const HeroBanner = () => {
  const { t } = useTranslation();
  return (
    <section id="HeroBanner">
      <div className="relative bg-cover bg-bottom opacity-80 h-screen bg-[url('../src/assets/images/home-banner-1.jpeg')] ">
        <div className="absolute inset-0 flex items-center justify-center lg:justify-start">
          <div className="bg-primary-100 bg-opacity-90 p-10 shadow-lg text-center max-w-lg mx-10 animate-fadeIn ">
            <p className="text-4xl md:text-4xl mb-4 opacity-0 animate-slideInFromLeft font-sans">
              {t("homepage.heroBanner.heading")}
            </p>
            <p className="text-lg md:text-xl mb-6 opacity-0 animate-slideInFromRight font-serif">
              {t("homepage.heroBanner.subheading")}
            </p>
            <p className="text-base text-text-400 mb-4">
              <MnLink
                to="/work-with-mn/individual-nutrition"
                name={t("homepage.heroBanner.linkText")}
              ></MnLink>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
